import { FC } from 'react';
import { Center, HStack } from '@chakra-ui/react';

import SunshineIcon from 'components/_core/SunshineIcon';
import Text from 'components/_core/Text';
import { FILE_TYPE } from 'components/Upload';
import BaseUpload from 'components/Upload/component';
import { UploadedFileInfo } from 'components/Upload/types';
import { uploadReceipt } from 'features/Storage/upload';

import locales from './locales';

interface UploadProps {
  createReceipt: (file: UploadedFileInfo) => Promise<void>;
}

const Upload: FC<UploadProps> = ({ createReceipt }) => (
  <BaseUpload
    backgroundColor="grey.200"
    dashedBorderColor="grey.500"
    errorMessage={locales.error}
    fileTypes={FILE_TYPE.ALLOWED_DOCUMENTS}
    onSuccessfulUpload={createReceipt}
    uploadFile={uploadReceipt}
  >
    <Center flexDirection="column" gap="space-4">
      <HStack gap="space-8">
        <SunshineIcon color="primary" name="download" size="icon-16" />

        <Text fontWeight="weight-500" variant="primary">
          {locales.dropZone.title}
        </Text>
      </HStack>

      <Text>{locales.dropZone.subtitle}</Text>
    </Center>
  </BaseUpload>
);

export default Upload;
